import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// MODIFIED: added AuthProvider + ProtectedRoute, and the Collections / About / ResetPassword routes
import AuthProvider from './Home/Components/AuthProvider';
// ADDED: holds the light/dark preference. Wraps everything, including the login screen.
import ThemeProvider from './Home/Components/ThemeProvider';
import ProtectedRoute from './Home/Components/ProtectedRoute';
// ADDED: asks for a username once, the first time an account without one signs in
import UsernameGate from './Home/Components/UsernameGate';
import NavBar from './Home/Components/NavBar';
import Login from './Home/Login';
import ResetPassword from './Home/ResetPassword';
import Home from './Home/Homescreen';
import Models from './Home/CarModels';
import Collections from './Home/Collections';
import Multipacks from './Home/Multipacks'; // ADDED
import Friends from './Home/Friends'; // ADDED
import FriendProfile from './Home/Friends/FriendProfile'; // ADDED
import Account from './Home/Account'; // ADDED: the user configuration page
import Footer from './Home/Components/Footer';

function App() {
    return (
        // ADDED: ThemeProvider sits outermost so every screen can read the theme
        <ThemeProvider>
            <AuthProvider>
                <Router>
                    {/* MODIFIED: a flex column, so the footer is pushed to the bottom
                        on short pages instead of floating mid-screen */}
                    <div className="cv-page min-h-screen flex flex-col">
                        <ConditionalNavBar />
                        <main className="flex-1">
                            <Routes>
                                {/* Public */}
                                <Route path="/login" element={<Login />} />
                                <Route path="/reset-password" element={<ResetPassword />} />

                                {/* Signed in only */}
                                <Route path="/models" element={<ProtectedRoute><Models /></ProtectedRoute>} />
                                <Route path="/collections" element={<ProtectedRoute><Collections /></ProtectedRoute>} />
                                {/* ADDED: the multipacks catalog */}
                                <Route path="/multipacks" element={<ProtectedRoute><Multipacks /></ProtectedRoute>} />
                                {/* ADDED: friends, and the read-only view of one friend's shared shelf */}
                                <Route path="/friends" element={<ProtectedRoute><Friends /></ProtectedRoute>} />
                                <Route path="/friends/:id" element={<ProtectedRoute><FriendProfile /></ProtectedRoute>} />
                                {/* ADDED: the account page needs a session, same as the two above */}
                                <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />

                                <Route path="/home" element={<Home />} />
                                <Route path="/" element={<Home />} />
                                {/* ADDED: anything unrecognised falls back to the landing page */}
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </main>
                        <Footer />
                        {/* ADDED: sits above everything. It renders nothing once a username exists. */}
                        <UsernameGate />
                    </div>
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

function ConditionalNavBar() {
    const location = useLocation();
    // MODIFIED: the reset-password screen is also shown without the nav bar
    const hideNavOn = ['/login', '/reset-password'];
    return hideNavOn.includes(location.pathname.toLowerCase()) ? null : <NavBar />;
}

export default App;
